:host {
    display: inline-block;
}

.name {
    font-family: var(--ux-font);
    font-size: var(--ux-input-label-font-size);
    font-weight: var(--ux-input-label-font-weight);
    line-height: var(--ux-input-label-line-height);
    text-transform: uppercase;
}

::slotted(*) {
    font-family: var(--ux-font);
}
